import React from 'react'

import {Switch, Route} from 'react-router-dom'
import Homeworks from './homeworks'
import HomeworkStudents from './homework-students'

const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}'
const homeworkPath = '/:languageId/:role/:page(homework)'

export default function HomeworkRouter () {
  return (<Switch>
      <Route exact path={`${homeworkPath}`} component={Homeworks} />
      <Route exact path={`${homeworkPath}/:homeworkId(${UUID})`} component={HomeworkStudents} />
  </Switch>)
}
